import { RouteConfig } from "vue-router";
import { UserState } from "@/store/modules/auth/interfaces";

export const candidate_interview_routes: RouteConfig = {
  path: "interviews",
  component: () =>
    import("@/views/candidate/interviews/CandidateInterviewsIndex.vue"),
  meta: {
    user_state: [UserState.CANDIDATE]
  },
  children: [
    {
      path: "ai",
      name: "candidate-ai-interview",
      component: () =>
        import("@/views/candidate/interviews/CandidateAiInterviewListing.vue"),
      meta: {
        name: "nav-sidebar.ai-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "ai/session",
      name: "candidate-ai-interview-session",
      component: () =>
        import("@/views/candidate/interviews/CandidateAiInterviewSession.vue"),
      meta: {
        name: "nav-sidebar.ai-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "ai/:inviteId",
      name: "candidate-ai-interview-details",
      component: () =>
        import("@/views/candidate/interviews/CandidateAiInterview.vue"),
      meta: {
        name: "nav-sidebar.ai-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "final",
      name: "candidate-final-interview",
      component: () =>
        import("@/views/candidate/interviews/CandidateFinalInterviewListing.vue"),
      meta: {
        name: "nav-sidebar.final-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "final/session",
      name: "candidate-final-interview-session",
      component: () =>
        import("@/views/candidate/interviews/CandidateFinalInterviewSession.vue"),
      meta: {
        name: "nav-sidebar.final-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "final/:inviteId",
      name: "candidate-final-interview-details",
      component: () =>
        import("@/views/candidate/interviews/CandidateFinalInterview.vue"),
      meta: {
        name: "nav-sidebar.final-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "ai/report",
      name: "candidate-ai-interview-report",
      redirect: { name: "candidate-ai-interview" },
      meta: {
        name: "nav-sidebar.ai-interview",
        icon: require("@/assets/icons/nav_sidebar/active/candidates.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "",
      name: "candidates-interviews",
      component: () =>
        import("@/views/candidate/interviews/CandidateInterviewsListing.vue"),
      meta: {
        name: "nav-sidebar.interviews",
        icon: require("@/assets/icons/nav_sidebar/active/teacher.svg"),
        user_state: [UserState.CANDIDATE]
      }
    },
    {
      path: "start/:interview_id",
      name: "interview-start",
      component: () =>
        import("@/views/candidate/interviews/CandidateInterviewRoot.vue"),
      meta: {
        name: "nav-sidebar.interviews",
        icon: require("@/assets/icons/nav_sidebar/active/teacher.svg"),
        user_state: [UserState.CANDIDATE]
      }
    }
  ]
};